<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-primary shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0" style="margin-top: auto;">
            <div class="row">
              <div class="col-lg-4">
                <card
                  class="border-0 d-flex card-hotel"
                  hover
                  shadow
                  body-classes="text-center align-items-center d-flex justify-content-center"
                >
                  <object
                    data="/img/svg/8-PBB-B2.svg"
                    type="image/svg+xml"
                    class="text-white card-pajak"
                  ></object>
                  <h6
                    class="text-white text-uppercase title-inside-card"
                    style="margin-top: 7px"
                  >PBB</h6>
                </card>
              </div>
              <div class="col-lg-8">
                <h1 class="display-3 text-white">
                  Pelayanan PBB
                  <span>Kabupaten Ketapang</span>
                </h1>
                <p
                  class="description mt-3 text-white"
                >Pajak Bumi dan Bangunan adalah pungutan atas tanah dan bangunan yang muncul karena adanya keuntungan dan/atau kedudukan sosial ekonomi bagi seseorang atau badan yang memiliki suatu hak atasnya, atau memperoleh manfaat dari padanya.</p>

                <p
                  class="description mt-3 text-white"
                >Jika dilihat dari sifatnya, Pajak Bumi dan Bangunan merupakan pajak yang bersifat kebendaan. Artinya, besaran pajak terutang ditentukan dari keadaan objek yaitu bumi dan/atau bangunan. Sedangkan keadaan subjeknya tidak ikut menentukan besarnya barang.</p>
                <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    class="mb-3 mb-sm-0"
                    type="info"
                    textColor="white"
                    icon="fa fa-arrow-left"
                    @click="goback()"
                  >Kembali</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <br>
    <br>
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-floppy-o" type="primary" rounded class="mb-4"></icon>
                  <h6 class="text-primary text-uppercase">Cek Pembayaran PBB</h6>
                  <p class="description mt-3">Mencari Histori pembayaran PBB-P2 berdasarkan NOP.</p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="primary"
                    class="mt-4"
                    @click="goPembayaranPbb()"
                  >Lanjutkan</base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-print" type="info" rounded class="mb-4"></icon>
                  <h6 class="text-info text-uppercase">Cetak SSPD</h6>
                  <p class="description mt-3">Mencetak SSPD PBB P2.</p><br>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="info"
                    class="mt-4"
                    @click="goSSPD()"
                  >Lanjutkan</base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-print" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">Informasi NOP</h6>
                  <p class="description mt-3">Informasi objek pajak PBB-P2 berdasarkan NOP.</p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="success"
                    class="mt-4"
                    @click="goObject()"
                  >Lanjutkan</base-button>
                </card>
              </div>
            </div>
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-print" type="info" rounded class="mb-4"></icon>
                  <h6 class="text-info text-uppercase">Cetak SPPT</h6>
                  <p class="description mt-3">Mencetak SPPT PBB P2.</p><br>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="info"
                    class="mt-4"
                    @click="goSppt()"
                  >Lanjutkan</base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-cog" type="warning" rounded class="mb-4"></icon>
                  <h6 class="text-warning text-uppercase">Peraturan PBB</h6>
                  <p
                    class="description mt-3"
                  >Dasar Hukum pemungutan PBB yang termuat dalam undang-undang.</p>
                  <base-button
                    tag="a"
                    textColor="white"
                    type="warning"
                    class="mt-4"
                    @click="goPBB()"
                  >Dasar Hukum</base-button>
                </card>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />
        <div class="row">
          <div class="col-md-12">
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
      </div>
    </section>

    <br />
    <br />
    <modal-informasi-pajak
      ref="modal-informasi-pajak"
      title="Pencarian Informasi Pembayaran Bumi dan Bangunan"
      code="1112"
      url="/ketapang/informasi/Pbb/detail-pembayaran/"
    ></modal-informasi-pajak>

    <modal-objek-pajak
      ref="modal-objek-pajak"
      title="Pencarian Informasi Objek Pajak"
      code="1112"
      url="/ketapang/informasi/Pbb/detail-nop/"
    ></modal-objek-pajak>
     <modal-cetak-sspd
      ref="modal-cetak-sspd"
      title="Pencetakan SSPD"
      code="1112"
      url="/ketapang/informasi/Pbb/report/sspd/"
    ></modal-cetak-sspd>
     <modal-cetak-sppt
      ref="modal-cetak-sppt"
      title="Pencetakan SPPT"
      code="1112"
      url="/ketapang/informasi/Pbb/report/sppt/"
    ></modal-cetak-sppt>
  </div>
</template>

<script>
import ModalInformasiPajak from "../GlobalPage/PajakPbb";
import ModalObjekPajak from "../GlobalPage/ObjekPajakNop";
import ModalCetakSspd from "../GlobalPage/PbbCetakSSPD";
import ModalCetakSppt from "../GlobalPage/PbbCetakSPPT";
import { Chart } from "highcharts-vue";
import Swal from "sweetalert2";
export default {
  name: "pbb",
  components: {
    ModalInformasiPajak,
    ModalObjekPajak,
    ModalCetakSspd,
    ModalCetakSppt,
    highcharts: Chart
  },
  data() {
    return {
      css: CssForBootstrap4,
      items: []
    };
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text: "Realisasi PBB berdasarkan Tahun"
        },
        subtitle: {
          text: "Data tahun yang di ambil adalah data 10 tahun kebelakang."
        },
        accessibility: {
          announceNewData: {
            enabled: true
          }
        },
        xAxis: {
          type: "category"
        },
        yAxis: {
          title: {
            text: "Jumlah Realisasi"
          }
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.y:.2f}"
            }
          }
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
        },

        series: [
          {
            name: "Tahun",
            colorByPoint: true,
            data: this.items
          }
        ]
      };
    }
  },
  created() {
    this.getRealisasi();
  },
  methods: {
    async getRealisasi() {
      try {
        this.isBusy = true;
        // let { data } = await axios.get("/api/v1/realisasi-pajak/pbb");

        // var items = [];
        // for (const [key, value] of Object.entries(data)) {
        //   this.items.push({
        //     name: value.thn_pajak_sppt,
        //     y: parseFloat(value.realisasi)
        //   });
        // }
      } catch (error) {
        Swal.fire({
          title: "",
          text: error.message,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!"
        });
      } finally {
        this.isBusy = false;
      }
    },
    goPembayaranPbb() {
      this.$refs["modal-informasi-pajak"].showModal();
    },
    goObject() {
      this.$refs["modal-objek-pajak"].showModal();
    },
    goSSPD() {
      this.$refs["modal-cetak-sspd"].showModal();
    },
    goSppt() {
      this.$refs["modal-cetak-sppt"].showModal();
    },
    goDasarHukum() {
      this.$router.push("/api/pbb/mutasi-wajib-pajak");
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.section-shaped .shape.shape-skew + .shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card-hotel {
  height: 100%;
}

.chart-wrapper {
  position: relative;
  padding-bottom: 40%;
}

.chart-inner {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>